import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import api from '@/shared/api';
import { ENDPOINTS } from '@/shared/constants';
import { toast } from 'react-toastify';

interface DelayedJourneyStagesCache {
  clientsWithDelayedStageTotal: number;
  delayedClientsByJourney: { [key: number]: number };
}

interface DelayedJourneyStagesCacheState {
  clientsWithDelayedStageTotal?: number;
  delayedClientsByJourney?: { [key: number]: number };
  loading: boolean;
  error: string | null;
}

// Estado inicial
const initialState: DelayedJourneyStagesCacheState = {
  loading: false,
  error: null,
};

// Função para buscar itens da API
export const fetchDelayedJourneyStagesCache =
  createAsyncThunk<DelayedJourneyStagesCache>(
    'journeys/fetchDelayedJourneyStagesCache',
    async (_, thunkAPI) => {
      try {
        const response = await api.get(
          ENDPOINTS.CLIENTS.GET.DELAYED_STAGES_CACHE
        );

        return (await response.data) as DelayedJourneyStagesCache;
      } catch (error: unknown) {
        toast.error('Erro ao listar listas de jornadas com etapas vencidas');
        let errorMessage = 'Unknown error';

        if (error instanceof Error) {
          errorMessage = error.message;
        }

        return thunkAPI.rejectWithValue(errorMessage);
      }
    }
  );

// Slice
const delayedJourneyStagesCache = createSlice({
  name: 'journeys',
  initialState,
  reducers: {
    // Exemplo de reducer adicional, se necessário
    clearError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDelayedJourneyStagesCache.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchDelayedJourneyStagesCache.fulfilled,
        (state, action: PayloadAction<DelayedJourneyStagesCache>) => {
          state.loading = false;
          state.clientsWithDelayedStageTotal =
            action.payload.clientsWithDelayedStageTotal;
          state.delayedClientsByJourney =
            action.payload.delayedClientsByJourney;
        }
      )
      .addCase(fetchDelayedJourneyStagesCache.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

// Exporta ações e reducer
export const { clearError } = delayedJourneyStagesCache.actions;
export default delayedJourneyStagesCache.reducer;
